<template>
  <div class="relative flex flex-col gap-2">
    <TransitionGroup name="banner-slide">
      <div v-for="item in notifications" :key="item.id" class="notification">
        <BaseSymbol :name="statusList[item.type]" />
        <div>{{ item.message }}</div>
        <button
          class="notification_close-btn"
          type="button"
          @click.stop="closeNotification(item.id)">
          <BaseIcon name="close" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { computed } from "vue";
import BaseSymbol from "@emcd-shared/base-symbol";
import BaseIcon from "@emcd-shared/base-icon";
import { useUiStore } from "@/stores/ui";

const uiStore = useUiStore();

const statusList = {
  success: "status_success",
  info: "status_alert",
  error: "status_error",
};

const notifications = computed(() => uiStore.notifications);

const closeNotification = (id) => {
  uiStore.notifications = uiStore.notifications.filter((item) => item.id !== id);
};
</script>
